import type { FC } from 'react';

interface SeoPreviewProps {
  title: string;
  slug: string;
  seoTitle: string;
  seoDescription: string;
}

const SeoPreview: FC<SeoPreviewProps> = ({ title, slug, seoTitle, seoDescription }) => {
  const displayTitle = seoTitle || title || "Titre de l'article";
  const displayDesc = seoDescription || 'Ajoutez une meta description pour optimiser le référencement...';
  const displaySlug = slug || 'mon-article';

  return (
    <div className="fc-card p-4">
      <p className="mb-3 text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400">
        Aperçu Google
      </p>
      <div className="space-y-1">
        <p className="truncate text-xs text-emerald-700 dark:text-emerald-400">
          feedbackcopilot.com/blog/{displaySlug}
        </p>
        <p className="cursor-pointer truncate text-base font-medium text-blue-700 hover:underline dark:text-blue-400">
          {displayTitle}
        </p>
        <p className="line-clamp-2 text-sm text-slate-600 dark:text-slate-400">{displayDesc}</p>
      </div>
      <div className="mt-2 flex gap-4 text-[10px] text-slate-400">
        <span className={seoTitle.length > 60 ? 'text-red-500' : ''}>
          Title : {seoTitle.length}/60
        </span>
        <span className={seoDescription.length > 155 ? 'text-red-500' : ''}>
          Desc : {seoDescription.length}/155
        </span>
      </div>
    </div>
  );
};

export default SeoPreview;
